import React from 'react';

import { Icon } from '@chakra-ui/react';

export const FullscreenIcon = props => (
  <Icon viewBox="0 0 20 20" color="inherit" h="full" w="full" {...props}>
    <rect x="0" fill="none" width="20" height="20" />

    <g>
      <path d="M7 2H2v5l1.8-1.8L6.5 8 8 6.5 5.2 3.8 7 2zm6 0l1.8 1.8L12 6.5 13.5 8l2.7-2.7L18 7V2h-5zm.5 10L12 13.5l2.7 2.7L13 18h5v-5l-1.8 1.8-2.7-2.8zm-7 0l-2.7 2.7L2 13v5h5l-1.8-1.8L8 13.5 6.5 12z" />
    </g>
  </Icon>
);
